<template>
  <div class="editable-wrapper">
    <input @click="makeEditable(true)" v-show="!edit" class="editable-wrapper-label cursor-pointer" :value="label">
    <div v-show="edit" class="editable-wrapper-input-wrapper">
      <slot name="input">
        <div class="editable-wrapper-input-parent">
          <slot name="input-element">
            <input v-if="type === 'text'" ref="input" :value="value" @input="setValue" type="text"
                   @keyup.esc="makeEditable(false)" @keyup.enter="doUpdate"
                   class="editable-wrapper-input-field">
            <select2
                v-else
                ref="input"
                :classes="['editable-wrapper-input-field']"
                :value="value"
                @change="selectedValue"
                :options="options"
                :config="config"
            />
          </slot>
        </div>
        <div class="editable-wrapper-input-buttons">
          <div class="editable-wrapper-input-buttons-wrap btn-group">
            <button @click="doUpdate" type="button" class="btn btn-light btn-sm shadow-lg p-2 me-1">
              <span class="svg-icon svg-icon-primary "><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo8/dist/../src/media/svg/icons/Navigation/Check.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <polygon points="0 0 24 0 24 24 0 24"/>
                      <path d="M6.26193932,17.6476484 C5.90425297,18.0684559 5.27315905,18.1196257 4.85235158,17.7619393 C4.43154411,17.404253 4.38037434,16.773159 4.73806068,16.3523516 L13.2380607,6.35235158 C13.6013618,5.92493855 14.2451015,5.87991302 14.6643638,6.25259068 L19.1643638,10.2525907 C19.5771466,10.6195087 19.6143273,11.2515811 19.2474093,11.6643638 C18.8804913,12.0771466 18.2484189,12.1143273 17.8356362,11.7474093 L14.0997854,8.42665306 L6.26193932,17.6476484 Z" fill="#000000" fill-rule="nonzero" transform="translate(11.999995, 12.000002) rotate(-180.000000) translate(-11.999995, -12.000002) "/>
                  </g>
              </svg><!--end::Svg Icon--></span>
              <!-- Save -->
            </button>
            <button @click="makeEditable(false)" type="button" class="btn btn-light btn-sm shadow-lg p-2">
              <span class="svg-icon svg-icon-primary"><!--begin::Svg Icon | path:/var/www/preview.keenthemes.com/metronic/releases/2021-05-14-112058/theme/html/demo8/dist/../src/media/svg/icons/Navigation/Close.svg--><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                          <rect x="0" y="7" width="16" height="2" rx="1"/>
                          <rect opacity="0.7" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000) " x="0" y="7" width="16" height="2" rx="1"/>
                      </g>
                  </g>
              </svg><!--end::Svg Icon--></span>

               <!-- Cancel --></button>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  model: {
    event: 'input',
    prop: 'value'
  },
  props: {
    override: null,
    label: {
      default: ''
    },
    type: {
      default: 'text',
      type: String
    },
    name: null,
    value: null,
    context: null,
    update: {
      default() {
      }
    },
    options: {
      default: () => []
    },
    config: {
      default: () => {
      }
    },
    disabled: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      edit: false,
      value_: undefined,
    }
  },
  methods: {
    makeEditable(value = true) {
      if(this.override){
        this.override()
        return;
      }

      if(this.disabled) return;

      this.edit = value

      if (!value) {
        this.value_ = this.value
        return
      }

      this.$nextTick(() => {
        switch (this.type) {
          default:
            this.$refs.input.focus()
        }
      })
    },
    setValue() {
      // this.$emit('input', this.$refs.input.value)
      this.value_ = this.$refs.input.value
    },
    selectedValue(value) {
      const val_ = value === undefined ? null : value;
      this.value_ = val_
    },
    setParentValue(value) {
      this.$emit('input', value)
    },
    doUpdate: async function () {
      let updateValue = typeof this.value_ === 'undefined' ? this.value : this.value_
      // console.log(updateValue)
      try {
        await this.update(this.name, updateValue, this.context)
        this.setParentValue(updateValue)
        this.makeEditable(false)
      } catch (e) {
        throw e
      }
    },
  }
}
</script>